import React from 'react';
import { MenuForm } from '../Menu.js';

import "../../css/main.css"




export function PermissionDeniedForm() {

    return (
        <div>
            
            {MenuForm()}
            <div className="contentdiv">
                <h1>Permission Denied</h1>
            </div>
        </div>);



}